import {InteractionState} from '@features/ai-chatbot/types.ts'

/**
 * Interaction states where only suggestion clicks are accepted — free text is
 * disabled because yes/no detection can't be done reliably across locales.
 */
export const SUGGESTION_ONLY_STATES = new Set<InteractionState['type']>([
    'conversation_ended',
    'confirmation_required',
    'anything_else_required',
    'comment_requested'
])

/**
 * The floating launcher, shared by the desktop popover trigger and the mobile
 * dialog button so the two entry points stay visually identical.
 */
export const CHAT_LAUNCHER_CLASSNAME =
    'bg-linear-(--gradient-rausch) fixed right-4 bottom-4 z-popover flex size-12 cursor-pointer items-center justify-center rounded-full text-white shadow-lg transition'
